import React, { useState } from 'react';
import { ActionIcon } from "@mantine/core";
import { IconArrowUpRight } from '@tabler/icons-react';
import { LineChart, Line } from 'recharts';
import { prepareChartDataFromCache } from '../../assets/constants';

const MiniLineChart = ({ data, questionId, callId, questionText}) => {
    const [isHovering, setIsHovering] = useState(false);

    const handleChartClick = () => {
        const newPageUrl = `/keystroke-history/${callId}/${questionId}`;
        window.open(newPageUrl, '_blank');
    }

    return (
        data.length <= 1
            ?
            <div />
            :
            <div
                style={{ position: 'relative', width: '140px', height: '70px' }}
                onClick = {handleChartClick}
            >
                {
                    isHovering &&
                    <ActionIcon color="gray" style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }}>
                        <IconArrowUpRight stroke={1.5} size={16} color='black' />
                    </ActionIcon>
                }
                <LineChart
                    width={140}
                    height={70}
                    data={prepareChartDataFromCache(data)}
                    cursor="pointer"
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                >
                    <Line
                        type="monotone"
                        dataKey="keystroke_time"
                        stroke={isHovering ? '#000' : '#333'}
                        strokeWidth={isHovering ? 1.5 : 1}
                        animationDuration={500}
                        dot={false}
                    />
                </LineChart>
            </div>
    );
};

export default MiniLineChart;